import * as React from 'react';
import omit from 'omit.js';
import classNames from 'classnames';
import { ConfigConsumer } from '../config-provider';
import Element from './Element';
const SkeletonAvatar = (props) => {
    const renderSkeletonAvatar = ({ getPrefixCls }) => {
        const { prefixCls: customizePrefixCls, className, active } = props;
        const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
        const otherProps = omit(props, ['prefixCls']);
        const cls = classNames(prefixCls, `${prefixCls}-element`, {
            [`${prefixCls}-active`]: active,
        }, className);
        return (<div className={cls}>
        <Element prefixCls={`${prefixCls}-avatar`} {...otherProps}/>
      </div>);
    };
    return <ConfigConsumer>{renderSkeletonAvatar}</ConfigConsumer>;
};
SkeletonAvatar.defaultProps = {
    size: 'default',
    shape: 'circle',
};
export default SkeletonAvatar;
